import styled from 'styled-components'

export const Success = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  padding: 1rem;
  background: ${({ theme }) => `${theme.palette.primary.main}22`};
  color: ${({ theme }) => theme.palette.primary.main};
  border-radius: ${({ theme }) => theme.borderRadius[3]};
`
